import React from 'react'
import Link from 'next/link'
import { getSlug } from '@/lib/utilities/Utils'

interface LocalityCardProps {
  localityName: string
  storeCount: number
  storeTypeName: string
  city: string
}

const LocalityCard = ({
  city,
  localityName,
  storeCount,
  storeTypeName
}: LocalityCardProps): JSX.Element => {
  const href = `/${getSlug(city)}/${getSlug(localityName)}/${getSlug(storeTypeName)}`

  return (
    <Link href={href} className='block w-full'>
      <div
        className='w-full cursor-pointer rounded-[20px] bg-white px-7 py-6
          border border-[#E1E1E1] transition-shadow hover:shadow-md'
      >
        <h3 className='text-lg font-black leading-[29px] text-black'>
          {localityName}
        </h3>

        <p className='mt-1 text-base font-normal leading-[24px] text-[#777777]'>
          {storeCount} {storeTypeName}
        </p>
      </div>
    </Link>
  )
}

export default LocalityCard
